import script from "./questions.vue?vue&type=script&setup=true&lang=js"
export * from "./questions.vue?vue&type=script&setup=true&lang=js"

import "./questions.vue?vue&type=style&index=0&id=5ab4081a&lang=less"

const __exports__ = script;

export default __exports__